import { InjectionToken } from '@angular/core'

export interface LaunchDarklyConfig {
  launchDarklyClientId: string
}

export const LAUNCH_DARKLY_CONFIG = new InjectionToken<LaunchDarklyConfig>('LAUNCH_DARKLY_CONFIG')
